<template>
  <footer class="xer-footer">
    <img :src="xeriusLogoUrl" class="xer-footer__logo" alt="Xerius logo" />
    <div class="xer-footer__content">
      <div class="xer-footer-info">
        <a
          :href="rootStore.juridischeInformatieUrl"
          class="xer-link xer-footer-info__link"
          target="_blank"
          rel="noopener noreferrer"
          v-html="rootStore.translate('Moez.JuridischeInformatie')"
        />
        <a
          :href="rootStore.cookieInformatieUrl"
          class="xer-link xer-footer-info__link"
          target="_blank"
          v-html="rootStore.translate('Moez.Cookieverklaring')"
        />
      </div>
      <div class="xer-footer-social">
        <a
          target="_blank"
          href="https://www.linkedin.com/company/xerius/"
          rel="noopener noreferrer"
          class="xer-link xer-link--icon"
          alt="linkedin."
        >
          <xer-icon xer-name="linkedin"></xer-icon>
        </a>
        <a
          target="_blank"
          href="https://www.facebook.com/xerius.be/"
          rel="noopener noreferrer"
          class="xer-link xer-link--icon"
          alt="facebook."
        >
          <xer-icon xer-name="facebook"></xer-icon>
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
import getPictogramUrl from '@/utils/get-pictogram-url';
import { mapStores } from 'pinia';
import { useRootStore } from '@/stores';

export default {
  computed: {
    ...mapStores(useRootStore),
    xeriusLogoUrl() {
      return getPictogramUrl('logo-name', 'xerius');
    }
  }
};
</script>
